export default __webpack_public_path__ + "edda9c74981863bc7104e46bfad8d2ae.png";